import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import { Call } from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { startStudentSetActive } from "@redux/actions/students/students";

const initialState = {
    data: null,
    apiError: null,
    availableTransactions: 0,
};

export const CurpValidate = createSlice({
    name: "CurpValidate",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        clearData: (state) => {
            state.data = initialState.data;
        },
        setApiError: (state, action) => {
            state.apiError = action.payload;
        },
        clearApiError: (state) => {
            state.apiError = initialState.apiError;
        },
        setAvailableTransactions: (state, action) => {
            state.availableTransactions = action.payload;
        },
        clearAvailableTransactions: (state) => {
            state.availableTransactions = initialState.availableTransactions;
        },
    },
});

export const {
    setData,
    clearData,
    setApiError,
    clearApiError,
    setAvailableTransactions,
    clearAvailableTransactions,
} = CurpValidate.actions;

export default CurpValidate.reducer;

//* Actions
export const startCheckAvailableTransactions = () => {
    return async (dispatch, getState) => {
        const { user } = getState().auth;

        dispatch(startUILoading());

        const resp = await Call(
            `services/curp-validate/check-available-transactions`,
            "GET"
        );

        if (resp.success || resp.success == 0) {
            dispatch(setAvailableTransactions(resp.success));
        } else if (user?.id === 1) {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startValidateCURP = (curp, showValidationSwal = true) => {
    return async (dispatch) => {
        //* INICIO: Validaciones antes de hacer dispatch
        if (showValidationSwal) {
            let swalMessage = null;

            if (!curp) {
                swalMessage = "Ingrese una CURP";
            } else if (curp?.length !== 18) {
                swalMessage = "La CURP debe contener dieciocho caracteres";
            }

            if (swalMessage) {
                Swal.fire({
                    title: "CURP incorrecta",
                    text: swalMessage,
                    icon: "warning",
                });
                return;
            }
        }
        //* FIN: Validaciones antes de hacer dispatch

        dispatch(startUILoading());

        const resp = await Call(
            `services/curp-validate/validate-curp`,
            "POST",
            {
                curp,
            }
        );

        if (resp.success) {
            dispatch(clearApiError());
            dispatch(setData(resp.success));
        } else if (resp?.status_code === 422) {
            errorHandler(resp);
        } else {
            dispatch(clearData());
            dispatch(setApiError(resp.error || true));
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startCreate = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `services/curp-validate/create`,
            "POST",
            values
        );

        if (resp.success) {
            dispatch(setData(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGet = (curp) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("curp", curp);

        const resp = await Call(
            `services/curp-validate/get`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setData(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteAndRequest = (student_number, callback = () => {}) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            html: `
                <p>Esta acción eliminará la CURP actual del alumno.</p>
                <p>El estudiante deberá volver a capturar su CURP desde su perfil.</p>
                <p class="fw-bold text-danger m-0">Esta acción no se puede deshacer.</p>
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
        });

        if (!result.isConfirmed) return;

        dispatch(startUILoading());

        const resp = await Call(
            "services/curp-validate/delete-and-request",
            "DELETE",
            { student_number }
        );

        if (resp.success) {
            dispatch(startStudentSetActive(resp.success));
            Swal.fire({
                title: "CURP eliminada",
                text: "El alumno deberá capturar nuevamente su CURP desde su perfil.",
                icon: "success",
                confirmButtonText: "Entendido",
            });
            callback();
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
